import Taxonomy from 'modules/contracts/store/models/Taxonomy'
import type Supplement from 'modules/payroll_bundle/store/models/Supplement'

import { PayrollLegalEntityResource } from './payrollLegalEntityResource'

export type ResourceModel = Taxonomy

class Taxonomies extends PayrollLegalEntityResource<Taxonomy> {
  get cacheKey(): string {
    return 'taxonomies'
  }

  model() {
    return Taxonomy
  }
}

const singleton: Taxonomies = new Taxonomies()

export const supplementTaxonomyName = (supplement: Supplement) => {
  return supplement.has('contracts_taxonomy_id')
    ? singleton.get(supplement.attributes.contracts_taxonomy_id)?.get('name') ?? ''
    : ''
}

export { Taxonomies }

export default singleton
